export default __webpack_public_path__ + "static/media/vijay.9aa3bc1e.jpg";